import React from "react";
import styles from "./EcommerceHero.module.css";
import Dustbin from "../../Images/Dustbin.jpg";
import Desktop from "../../Images/Desktop.jpg";
import Store from "../../Images/ECommerceStore.jpg";
import Apparel from "../../Images/Apparel.jpg";
import Retail from "../../Images/Retail.jpg";
import Factory from "../../Images/Factory.jpg";
import SaraChen from "../../Images/Sara Chen.jpg";



const HeroSection = () => {
  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className={styles.hero}>
        <div className={styles.container}>
          <div className={styles.content}>
            <span className={styles.tag}>AI-Powered E-commerce Solutions</span>

            <h1 className={styles.heading}>
              Recover Carts.<br />
              Resolve Tickets.<br />
              <span className={styles.highlight}>Scale Revenue.</span>
            </h1>

            <p className={styles.description}>
              Deploy human-like AI voice agents that recover 25% of abandoned
              carts and automate 70% of your support volume.
              <br />
              24/7 engagement that scales with your store.
            </p>

            <div className={styles.ctaGroup}>
              <button className={`${styles.button} ${styles.primary}`}>
                Book a Demo →
              </button>
              <button className={`${styles.button} ${styles.outline}`}>
                View Pricing
              </button>
            </div>
          </div>

          <div className={styles.imageWrapper}>
            <img
              src={Dustbin}
              alt="Dustbin"
              className={styles.image}
            />
          </div>
        </div>
      </section>

      {/* ================= EFFICIENCY GAP SECTION ================= */}
      <section className={styles.efficiencyGap}>
        <h2 className={styles.efficiencyGapTitle}>
          The Efficiency Gap
        </h2>

        <div className={styles.efficiencyGapCards}>
          {/* Problem Card */}
          <div className={`${styles.efficiencyCard} ${styles.problemCard}`}>
            <div className={styles.problemIcon}><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="White" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square-icon lucide-message-square"><path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"/></svg></div>
            <h3>The Problem</h3>
            <p>
              Traditional E-commerce support is slow and reactive. Email cart
              recovery is ignored, and “Where is my order?” (WISMO) tickets
              drain your team's productivity.
            </p>
          </div>

          {/* Solution Card */}
          <div className={`${styles.efficiencyCard} ${styles.solutionCard}`}>
            <div className={styles.solutionIcon}><svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 24 24" fill="none" stroke="White" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sparkles-icon lucide-sparkles"><path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"/><path d="M20 2v4"/><path d="M22 4h-4"/><circle cx="4" cy="20" r="2"/></svg></div>
            <h3>The ToxBox Solution</h3>
            <p>
              We replace static notifications with proactive AI voice
              interactions. Toxbox talks to your customers in real-time to
              solve problems before they turn into churn.
            </p>
          </div>
        </div>
      </section>

      {/* ================= CORE E-COMMERCE CAPABILITIES SECTION ================= */}
      <section className={styles.coreCapabilities}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Core E-commerce Capabilities</h2>
          <p className={styles.sectionSubtitle}>
            Empower your store with intelligent AI solutions
          </p>
        </div>

        <div className={styles.capabilitiesGrid}>
          {/* Card 1: Smart Cart Recovery */}
          <div className={styles.capabilityCard}>
            <div className={styles.iconWrapper} style={{ backgroundColor: '#f3e8ff' }}>
              <span className={styles.icon}>🛒</span>
            </div>
            <h3 className={styles.cardTitle}>Smart Cart Recovery</h3>
            <p className={styles.cardDescription}>
              Automated voice follow-ups to abandoned checkouts. Answer questions, offer discounts, and close the sale instantly.
            </p>
          </div>

          {/* Card 2: WISMO Automation */}
          <div className={styles.capabilityCard}>
            <div className={styles.iconWrapper} style={{ backgroundColor: '#e0f2fe' }}>
              <span className={styles.icon}>📦</span>
            </div>
            <h3 className={styles.cardTitle}>WISMO Automation</h3>
            <p className={styles.cardDescription}>
              Connects to your logistics (FedEx/UPS/DHL) to provide instant, real-time order tracking over the phone.
            </p>
          </div>

          {/* Card 3: Instant Returns/Exchanges */}
          <div className={styles.capabilityCard}>
            <div className={styles.iconWrapper} style={{ backgroundColor: '#fef3c7' }}>
              <span className={styles.icon}>🔄</span>
            </div>
            <h3 className={styles.cardTitle}>Instant Returns/Exchanges</h3>
            <p className={styles.cardDescription}>
              AI agents guide customers through returns and generate labels without human intervention.
            </p>
          </div>

          {/* Card 4: 24/7 Virtual Stylist */}
          <div className={styles.capabilityCard}>
            <div className={styles.iconWrapper} style={{ backgroundColor: '#fde9fe' }}>
              <span className={styles.icon}>✨</span>
            </div>
            <h3 className={styles.cardTitle}>24/7 Virtual Stylist</h3>
            <p className={styles.cardDescription}>
              Intelligent product recommendations and sizing advice to reduce return rates.
            </p>
          </div>
        </div>
      </section>

      {/* ================= WHY E-COMMERCE BRANDS CHOOSE TOXBOX ================= */}
      <section className={styles.whyToxbox}>
        <h2 className={styles.whyToxboxTitle}>Why E-commerce Brands Choose Toxbox</h2>

        <div className={styles.whyTable}>
          {/* Header Row */}
          <div className={styles.tableRow} style={{ backgroundColor: '#7C3AED', color: 'white' }}>
            <div className={styles.tableCell}>Feature</div>
            <div className={styles.tableCell}>Benefit</div>
          </div>

          {/* Row 1: Instant Response */}
          <div className={styles.tableRow}>
            <div className={styles.tableCell}>
              <span className={styles.featureIcon}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-zap-icon lucide-zap">
                  <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" fill="#7C3AED"/>
                </svg>
              </span>
              Instant Response
            </div>
            <div className={styles.tableCell}>
              No more "on-hold" music; 100% of calls answered in &lt;30s.
            </div>
          </div>

          {/* Row 2: CRM Sync */}
          <div className={styles.tableRow}>
            <div className={styles.tableCell}>
              <span className={styles.featureIcon}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="36" viewBox="0 0 24 24" fill="#7C3AED" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-database-icon lucide-database">
                  <ellipse cx="12" cy="5" rx="9" ry="3"/>
                  <path d="M3 5V19A9 3 0 0 0 21 19V5"/>
                  <path d="M3 12A9 3 0 0 0 21 12" fill="#7C3AED"/>
                </svg>
              </span>
              CRM Sync
            </div>
            <div className={styles.tableCell}>
              Instant data logging in Shopify, Magento, or Salesforce.
            </div>
          </div>

          {/* Row 3: Cost Reduction */}
          <div className={styles.tableRow}>
            <div className={styles.tableCell}>
              <span className={styles.featureIcon}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-right-icon lucide-chevron-right">
                  <path d="m9 18 6-6-6-6" fill="#7C3AED"/>
                </svg>
              </span>
              Cost Reduction
            </div>
            <div className={styles.tableCell}>
              Reduce overhead by automating repetitive Tier-1 inquiries.
            </div>
          </div>

          {/* Row 4: Human-Like Voice */}
          <div className={styles.tableRow}>
            <div className={styles.tableCell}>
              <span className={styles.featureIcon}>
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-phone-icon lucide-phone">
                  <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" fill="#7C3AED"/>
                </svg>
              </span>
              Human-Like Voice
            </div>
            <div className={styles.tableCell}>
              Natural processing (NLP) that sounds like a local agent.
            </div>
          </div>
        </div>
      </section>

      {/* ================= INTEGRATION ECOSYSTEM SECTION ================= */}
      <section className={styles.integrationEcosystem}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Integration Ecosystem</h2>
          <p className={styles.sectionSubtitle}>
            Toxbox slides into your existing workflow without changing your tech stack
          </p>
        </div>

        <div className={styles.ecosystemGrid}>
          {/* Storefronts */}
          <div className={styles.ecosystemCard}>
            <h3 className={styles.cardTitle}>Storefronts</h3>
            <div className={styles.pillList}>
              <span className={styles.pill}>Shopify</span>
              <span className={styles.pill}>BigCommerce</span>
              <span className={styles.pill}>WooCommerce</span>
            </div>
          </div>

          {/* Helpdesks */}
          <div className={styles.ecosystemCard}>
            <h3 className={styles.cardTitle}>Helpdesks</h3>
            <div className={styles.pillList}>
              <span className={styles.pill}>Zendesk</span>
              <span className={styles.pill}>Gorgias</span>
              <span className={styles.pill}>Freshdesk</span>
            </div>
          </div>

          {/* Marketing */}
          <div className={styles.ecosystemCard}>
            <h3 className={styles.cardTitle}>Marketing</h3>
            <div className={styles.pillList}>
              <span className={styles.pill}>Klaviyo</span>
              <span className={styles.pill}>HubSpot</span>
              <span className={styles.pill}>Mailchimp</span>
            </div>
          </div>
        </div>
      </section>

      {/* ================= IMPLEMENTATION ROADMAP SECTION (SVG CIRCLES) ================= */}
      <section className={styles.roadmap}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Implementation Roadmap</h2>
          <p className={styles.sectionSubtitle}>
            Get started in three simple steps
          </p>
        </div>

        <div className={styles.roadmapSteps}>
          {/* Step 1: Connect */}
          <div className={styles.stepCard}>
            <div className={styles.stepNumberSvg}>
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="32" fill="#7C3AED" />
                <text x="32" y="38" textAnchor="middle" fill="white" fontSize="24" fontWeight="700" fontFamily="sans-serif">1</text>
              </svg>
            </div>
            <h3 className={styles.stepTitle}>Connect</h3>
            <p className={styles.stepDescription}>
              Link Toxbox to your store API
            </p>
          </div>

          {/* Step 2: Train */}
          <div className={styles.stepCard}>
            <div className={styles.stepNumberSvg}>
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="32" fill="#7C3AED" />
                <text x="32" y="38" textAnchor="middle" fill="white" fontSize="24" fontWeight="700" fontFamily="sans-serif">2</text>
              </svg>
            </div>
            <h3 className={styles.stepTitle}>Train</h3>
            <p className={styles.stepDescription}>
              Upload your FAQ and brand guidelines
            </p>
          </div>

          {/* Step 3: Go Live */}
          <div className={styles.stepCard}>
            <div className={styles.stepNumberSvg}>
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="32" fill="#7C3AED" />
                <text x="32" y="38" textAnchor="middle" fill="white" fontSize="24" fontWeight="700" fontFamily="sans-serif">3</text>
              </svg>
            </div>
            <h3 className={styles.stepTitle}>Go Live</h3>
            <p className={styles.stepDescription}>
              AI agents begin handling recovery and support calls immediately
            </p>
          </div>
        </div>
      </section>

      {/* ================= AI SOLUTIONS ACROSS RETAIL CHANNELS ================= */}
      <section className={styles.aiSolutions}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>AI Solutions Across Retail Channels</h2>
          <p className={styles.sectionSubtitle}>
            Comprehensive AI-powered solutions for different retail segments
          </p>
        </div>

        <div className={styles.channelsGrid}>
          {/* Card 1: E-commerce Stores */}
          <div className={styles.channelCard}>
            <div className={styles.cardImageWrapper}>
              <img
                src={Store}
                alt="Modern minimalist e-commerce store entrance (Zara-style)"
                className={styles.cardImage}
              />
            </div>
            <h3 className={styles.cardTitle}>E-commerce Stores</h3>
            <p className={styles.cardDescription}>
              Enhance your online store with AI-powered product recommendations and customer support.
            </p>
          </div>

          {/* Card 2: Fashion & Apparel */}
          <div className={styles.channelCard}>
            <div className={styles.cardImageWrapper}>
              <img
                src={Apparel}
                alt="Puma store front with digital display and customer"
                className={styles.cardImage}
              />
            </div>
            <h3 className={styles.cardTitle}>Fashion & Apparel</h3>
            <p className={styles.cardDescription}>
              Provide personalized styling recommendations and virtual try-on experiences.
            </p>
          </div>

          {/* Card 3: Electronics Retail */}
          <div className={styles.channelCard}>
            <div className={styles.cardImageWrapper}>
              <img
                src={Retail}
                alt="Woman comparing smartphone and credit card at home"
                className={styles.cardImage}
              />
            </div>
            <h3 className={styles.cardTitle}>Electronics Retail</h3>
            <p className={styles.cardDescription}>
              Offer intelligent product comparisons and technical support automation.
            </p>
          </div>

          {/* Card 4: Mobile & Omnichannel */}
          <div className={styles.channelCard}>
            <div className={styles.cardImageWrapper}>
              <img
                src={Factory}
                alt="Warehouse with forklift and shelves (omnichannel logistics)"
                className={styles.cardImage}
              />
            </div>
            <h3 className={styles.cardTitle}>Mobile & Omnichannel</h3>
            <p className={styles.cardDescription}>
              Deliver seamless shopping experiences across all channels and devices.
            </p>
          </div>
        </div>
      </section>

      {/* ================= WHY CHOOSE TOXBOX AI FOR RETAIL? ================= */}
      <section className={styles.whyRetail}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Why Choose ToxBox AI for Retail?</h2>
          <p className={styles.sectionSubtitle}>
            Transform how your retail operations run with conversational AI solutions that deliver measurable results
          </p>
        </div>

        <div className={styles.retailCards}>
          {/* Card 1: Revenue Growth */}
          <div className={styles.retailCard}>
            <div className={styles.iconWrapper} style={{ backgroundColor: '#f3e8ff' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="#7C3AED" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-zap-icon lucide-zap">
                <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" fill="#7C3AED" />
              </svg>
            </div>
            <h3 className={styles.cardTitle}>Revenue Growth</h3>
            <p className={styles.cardDescription}>
              Increase sales by 4X through personalized recommendations and optimized pricing strategies.
            </p>
          </div>

          {/* Card 2: 24/7 Customer Support */}
          <div className={styles.retailCard}>
            <div className={styles.iconWrapper} style={{ backgroundColor: '#f3e8ff' }}>
             <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#7c3aed"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <circle cx="12" cy="12" r="10" />
  <path d="M12 6v6l4 2" />
</svg>

            </div>
            <h3 className={styles.cardTitle}>24/7 Customer Support</h3>
            <p className={styles.cardDescription}>
              Provide around-the-clock support that handles 98% of customer inquiries instantly.
            </p>
          </div>

          {/* Card 3: Seamless Shopping Experience */}
          <div className={styles.retailCard}>
            <div className={styles.iconWrapper} style={{ backgroundColor: '#f3e8ff' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="#7C3AED" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-sparkles-icon lucide-sparkles">
                <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"/>
                <path d="M20 2v4" fill="#7C3AED" opacity="0.5"/>
                <path d="M22 4h-4" fill="#7C3AED" opacity="0.5"/>
                <circle cx="4" cy="20" r="2" fill="#7C3AED" opacity="0.7"/>
              </svg>
            </div>
            <h3 className={styles.cardTitle}>Seamless Shopping Experience</h3>
            <p className={styles.cardDescription}>
              Create seamless shopping journeys with personalized experiences across all channels.
            </p>
          </div>

          {/* Card 4: Actionable Insights */}
          <div className={styles.retailCard}>
            <div className={styles.iconWrapper} style={{ backgroundColor: '#f3e8ff' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-database-icon lucide-database">
                <ellipse cx="12" cy="5" rx="9" ry="3"/>
                <path d="M3 5V19A9 3 0 0 0 21 19V5" fill="#7C3AED" opacity="0.5"/>
                <path d="M3 12A9 3 0 0 0 21 12"/>
              </svg>
            </div>
            <h3 className={styles.cardTitle}>Actionable Insights</h3>
            <p className={styles.cardDescription}>
              Unlock deep predictive insights about trends and customer behavior.
            </p>
          </div>
        </div>
      </section>

      {/* ================= WHAT RETAIL LEADERS SAY (COMPLETE SECTION) ================= */}
      <section className={styles.retailTestimonial}>
        {/* HEADING + SUBTITLE */}
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>What Retail Leaders Say</h2>
          <p className={styles.sectionSubtitle}>
            Hear from executives who transformed their retail operations with ToxBox AI
          </p>
        </div>

        {/* TESTIMONIAL CARD */}
        <div className={styles.testimonialCard}>
          {/* Double Quote Icon - Top Left */}
          <div className={styles.quoteIcon}>
           <svg viewBox="0 0 24 24" className="w-6 h-6" fill="#facc15">
  <path d="M9.5 5C7.57 6.53 6 8.93 6 12v7h6v-7H8.5c0-2.21.9-4.21 2.5-5.5L9.5 5zm8 0C15.57 6.53 14 8.93 14 12v7h6v-7h-3.5c0-2.21.9-4.21 2.5-5.5L17.5 5z"/>
</svg>
          </div>

          <blockquote className={styles.quoteText}>
            "ToxBox AI has completely transformed our retail experience. The AI-powered customer service has reduced our response time by 80% while increasing customer satisfaction scores. The personalized recommendations have boosted our average order value by 35%. This is next-gen retail at its finest."
          </blockquote>

          <div className={styles.authorInfo}>
            <div className={styles.authorAvatar}>
              {/* <span className={styles.authorInitials}>JR</span>*/}

               <img
    src={SaraChen}
    alt="SaraChen"
    className={styles.avatarImage}
  />
            </div>
            <div>
              <strong className={styles.authorName}>Jennifer Rodriguez</strong>
              <div className={styles.authorTitle}>VP of Retail - ACME Solutions</div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= STOP LOSING SALES TO SILENCE (SINGLE CARD) ================= */}
      <section className={styles.stopLosingSales}>
        <div className={styles.card}>
          {/* Image Overlay (Left Half) */}
          <div className={styles.imageOverlay}>
            <img
              src={Desktop}
              alt="Retail support agent using AI-powered headset"
              className={styles.cardImage}
            />
          </div>

          {/* Content (Right Half, overlaid on purple) */}
          <div className={styles.contentOverlay}>
            <h2 className={styles.mainTitle}>
              Stop Losing Sales to Silence
            </h2>
            <p className={styles.subtitle}>
              Join the next generation of retail. Let Toxbox handle the conversation while you focus on the brand.
            </p>

            <button className={`${styles.ctaButton} ${styles.primary}`}>
              Get Started for Free →
            </button>

            <div className={styles.benefitsList}>
              <div className={styles.benefitItem}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L12 13.17 9.41 10.59 8 12z" fill="white"/>
                </svg>
                <span>No credit card required</span>
              </div>
              <div className={styles.benefitItem}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L12 13.17 9.41 10.59 8 12z" fill="white"/>
                </svg>
                <span>14-day free trial</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;